import { render } from "./PaymentNeeded.vue?vue&type=template&id=5fc877f3&scoped=true"
import script from "./PaymentNeeded.vue?vue&type=script&lang=js"
export * from "./PaymentNeeded.vue?vue&type=script&lang=js"

import "./PaymentNeeded.vue?vue&type=style&index=0&id=5fc877f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fc877f3"]])

export default __exports__